module.exports = __webpack_public_path__ + "media/thumbnails/body-style-2-d1e01738.svg";